import { getHslLightness } from '~/utils/getHslLightness'
import { formatCssFontFamily, normalizeThemeFont, syncThemeFontStylesheet } from '~/utils/theme-font'

export default defineNuxtPlugin(() => {
  const themeStyleStore = useThemeStyleStore()

  const setPrimaryColor = () => {
    const { red: pr, green: pg, blue: pb } = themeStyleStore.primaryColor
    const { red: sr, green: sg, blue: sb } = themeStyleStore.secondaryColor
    const primaryColor = `rgb(${pr}, ${pg}, ${pb})`
    const secondaryColor = `rgb(${sr}, ${sg}, ${sb})`

    const root = document.documentElement
    root.style.setProperty('--wft-primary-color', primaryColor)
    root.style.setProperty('--wft-secondary-color', secondaryColor)
    const fontFamily = normalizeThemeFont(themeStyleStore.font).fontFamily
    root.style.setProperty('--wft-font-family', fontFamily ? formatCssFontFamily(fontFamily) : '')
    root.style.setProperty('--wft-primary-opacity-color', `rgba(${pr}, ${pg}, ${pb}, 0.1)`)
    root.style.setProperty('--wft-secondary-opacity-color', `rgba(${sr}, ${sg}, ${sb}, 0.1)`)
    root.style.setProperty('--wft-primary-text-color', getHslLightness(primaryColor) > 0.55 ? 'black' : 'white')
    root.style.setProperty('--wft-secondary-text-color', getHslLightness(secondaryColor) > 0.55 ? 'black' : 'white')
    root.style.setProperty('--wft-primary-text-reversed', getHslLightness(primaryColor) > 0.55 ? 'white' : 'black')
    root.style.setProperty('--wft-secondary-text-reversed', getHslLightness(secondaryColor) > 0.55 ? 'white' : 'black')
  }

  watch(() => themeStyleStore.primaryColor, () => {
    setPrimaryColor()
  }, {
    deep: true,
  })

  watch(() => themeStyleStore.font, () => {
    setPrimaryColor()
    syncThemeFontStylesheet(themeStyleStore.font)
  }, {
    deep: true,
    immediate: true,
  })

  // Initialize the primary color
  setPrimaryColor()
})
